module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-bar-graph-bf4e0e80.svg";